import _property from 'lodash/property';
export var ID_FIELD_NAME = 'id';
export var ROLE_ID_FIELD_NAME = 'roleId';
export var EMPLOYEE_KEYS = {
  ID: ID_FIELD_NAME,
  EMAIL: 'email',
  USER_ID: 'userId',
  NAME: 'name',
  EMPLOYEE_DISPLAY_NAME: 'empDisplayName',
  ADDRESS: 'address',
  F_NAME: 'fname',
  FIRST_NAME: 'firstName',
  L_NAME: 'lname',
  LAST_NAME: 'lastName',
  MIDDLE_NAME: 'middleName',
  DISPLAY_NO: 'displayNo',
  EXTERNAL_ID: 'externalId',
  DEPARTMENT_ID: 'departmentId',
  EMPLOYEE_CERTIFICATION_NUMBER: 'employeeCertificationNumber',
  ACTIVE: 'active',
  OT_CONFIGURATION_CODE: 'otConfigurationCode',
  WORK_WEEK: 'workWeek',
  PAYMENT_CYCLE: 'paymentCycle',
  DEALERSHIP_DEPARTMENT_NAME: 'dealershipDepartmentName',
  CLOCK_IN_REQUIRED: 'clockInRequired',
  JOB_TITLE: 'jobTitle',
  ROLE_ID: ROLE_ID_FIELD_NAME,
  EMPLOYEE_DISPLAY_NUMBER: 'empDisplayNo',
  PAYROLL_EMPLOYEE: 'payrollEmployee'
};

var id = _property(EMPLOYEE_KEYS.ID);

var email = _property(EMPLOYEE_KEYS.EMAIL);

var userId = _property(EMPLOYEE_KEYS.USER_ID);

var userName = _property(EMPLOYEE_KEYS.NAME);

var displayName = _property(EMPLOYEE_KEYS.EMPLOYEE_DISPLAY_NAME);

var address = _property(EMPLOYEE_KEYS.ADDRESS);

var fname = _property(EMPLOYEE_KEYS.F_NAME);

var firstName = _property(EMPLOYEE_KEYS.FIRST_NAME);

var lname = _property(EMPLOYEE_KEYS.L_NAME);

var lastName = _property(EMPLOYEE_KEYS.LAST_NAME);

var middleName = _property(EMPLOYEE_KEYS.MIDDLE_NAME);

var displayNumber = _property(EMPLOYEE_KEYS.DISPLAY_NO);

var externalId = _property(EMPLOYEE_KEYS.EXTERNAL_ID);

var departmentId = _property(EMPLOYEE_KEYS.DEPARTMENT_ID);

var certificationNumber = _property(EMPLOYEE_KEYS.EMPLOYEE_CERTIFICATION_NUMBER);

var active = _property(EMPLOYEE_KEYS.ACTIVE);

var otConfigurationCode = _property(EMPLOYEE_KEYS.OT_CONFIGURATION_CODE);

var workWeek = _property(EMPLOYEE_KEYS.WORK_WEEK);

var paymentCycle = _property(EMPLOYEE_KEYS.PAYMENT_CYCLE);

var dealershipDepartmentName = _property(EMPLOYEE_KEYS.DEALERSHIP_DEPARTMENT_NAME);

var clockInRequired = _property(EMPLOYEE_KEYS.CLOCK_IN_REQUIRED);

var jobTitle = _property(EMPLOYEE_KEYS.JOB_TITLE);

var roleId = _property(EMPLOYEE_KEYS.ROLE_ID);

var employeeDisplayNumber = _property(EMPLOYEE_KEYS.EMPLOYEE_DISPLAY_NUMBER);

var payrollEmployee = _property(EMPLOYEE_KEYS.PAYROLL_EMPLOYEE);

var READER = {
  id: id,
  email: email,
  userId: userId,
  userName: userName,
  displayName: displayName,
  address: address,
  fname: fname,
  firstName: firstName,
  lname: lname,
  lastName: lastName,
  middleName: middleName,
  displayNumber: displayNumber,
  externalId: externalId,
  certificationNumber: certificationNumber,
  departmentId: departmentId,
  active: active,
  otConfigurationCode: otConfigurationCode,
  workWeek: workWeek,
  paymentCycle: paymentCycle,
  dealershipDepartmentName: dealershipDepartmentName,
  clockInRequired: clockInRequired,
  jobTitle: jobTitle,
  roleId: roleId,
  employeeDisplayNumber: employeeDisplayNumber,
  payrollEmployee: payrollEmployee
};
export default READER;